import React from "react";

import { formatDate } from "../../../../../utils/strings";
import { DateFormat } from "../../../../../utils/types";
import { Note } from "./styles";
import { SectionFreshnessNoteProps } from "./types";

// Says nothing for a current section: market-data staleness is `valuationState`'s to report, never this note's.
export const SectionFreshnessNote: React.FC<SectionFreshnessNoteProps> = ({
  freshness,
}) => {
  if (freshness?.state !== "RETAINED") {
    return null;
  }
  const generatedText = formatDate(freshness.generatedAt, DateFormat.DM_TIME);
  return <Note role="status">Retained · generated {generatedText}</Note>;
};
